// @flow weak

import React, {
  PureComponent
}                     from 'react';
import PropTypes      from 'prop-types';
import AnimatedView   from '../../components/animatedView/AnimatedView';
import { button, Link, BrowserRouter, Route, Switch, Redirect, withRouter } from 'react-router-dom';

class Children extends PureComponent {
  constructor(props) {
    super(props);
    //console.log(props.match.params.file);
    this.state = {
			data: []
    };
  }

  componentDidMount() {
    this.setState({data: this.props.item});
  }

  componentWillUpdate(nextProps, nextState) {
    if(nextProps.currentFolderID != this.props.currentFolderID) {
        if(nextProps.currentFolderID === this.props.floderID){
          this.setState({data: nextProps.item});
        }
      }
  }

  componentWillUnmount() {
  }

  handleClick(item,e) {
		var children = jQuery("#parent_"+ item.id).children("ul");
		if (children.is(":visible")) {
			jQuery("#parent_"+ item.id +">i").removeClass("icon-icn_flight_folder_open3");
			jQuery("#parent_"+ item.id +">i").addClass("icon-icn_flight_folder_01");
      children.css('display','none');
			children.hide('fast');
		} else {
			jQuery("#parent_"+ item.id +">i").removeClass("icon-icn_flight_folder_01");
			jQuery("#parent_"+ item.id +">i").addClass("icon-icn_flight_folder_open3");
      children.css('display','block');
			children.show('fast');
		}
		//e.stopPropagation();
	}

  getChildren(data) {
    var self = this;
    const folders = [];
    data.map((item, index) => {
      var id = "parent_"+item.id;
      if( item.scheme == "album" ) {
        var empty = (item.size == 0) ? {color:"#999999"} : {};
        var folder =
          <li id={id} key={index}>
            <Link to={{ pathname: `/images/${item.id}`, state: {albumName: `${item.name}`} }} style={empty}>
              <i className="icon-icn_album_01" style={empty}></i>
              {item.name}
            </Link>
          </li>;
      } else if ( item.children ) {
        var chillen = (item.children) ? self.getChildren(item.children) : null;
        var folder =
          <li className="parent_li" id={id} key={index}>
            <i className="icon-icn_flight_folder_01" onClick={this.handleClick.bind(this,item)}></i>
            <a href="javascript:;" onClick={this.handleClick.bind(this,item)}>
              {item.name}
            </a>
            <ul>
              {chillen}
            </ul>
          </li>;
      } else {
        var folder =
          <li id={id} key={index}>
            <i className="icon-icn_flight_folder_open3"></i>
            {item.name}
          </li>;
      }
      folders.push(folder);
    });
    //this.setState({folders: folders});
    return folders;
  }

  render() {
    var self = this;
    return(
      <div>
			{ this.state.data.map((item,index) => {
        var id = "parent_"+item.id;
				var children = [];

				if( item.scheme == "album" ) {
          var empty = (item.size == 0) ? {color:"#999999"} : {};
          var folder =
            <li key={index}>
              <Link to={{ pathname: `/images/${item.id}`, state: {albumName: `${item.name}`} }} style={empty}>
                <i className="icon-icn_album_01" style={empty}></i>
                {item.name}
              </Link>
            </li>;
				} else if ( item.children ) {
  					for (var i = 0; i < item.children.length; i++) {
              var id = "parent_"+item.children[i].id;
  						if( item.children[i].scheme == "album" ) {
                var empty = (item.size == 0) ? {color:"#999999"} : {};
                var folder =
                  <li id={id} key={i}>
                    <Link to={{ pathname: `/images/${item.children[i].id}`, state: {albumName: `${item.children[i].name}`} }} style={empty}>
                      <i className="icon-icn_album_01" style={empty}></i>
                      {item.children[i].name}
                    </Link>
                  </li>;
  							//var icon = "icon-icn_album_01";
  							//var click = self.props.onClick.bind(this,item.children[i]);
  						} else {
                var chillen = (item.children[i].children) ? self.getChildren(item.children[i].children) : null;
                var folder =
                  <li id={id} key={i}>
                    <i className="icon-icn_flight_folder_01" onClick={this.handleClick.bind(this,item.children[i])}></i>
                    <a href="javascript:;" onClick={this.handleClick.bind(this,item.children[i])}>
                      {item.children[i].name}
                    </a>
                    <ul>
                      {chillen}
                    </ul>
                  </li>;
  						}

              children.push(folder);
  					}
            var id = "parent_"+item.id;
            var folder =
              <li id={id} key={index}>
                <i className="icon-icn_flight_folder_01" onClick={self.handleClick.bind(this,item)}></i>
                <a href="javascript:;" onClick={self.handleClick.bind(this,item)}>
                  {item.name}
                </a>
                <ul key={index}>
                  {children}
                </ul>
              </li>;
				} else {
          var folder =
            <li key={index}>
              <i className="icon-icn_flight_folder_open3"></i>
              {item.name}
            </li>;
				}

        return(
          <ul key={index}>
            {folder}
          </ul>
        )
			})}
      </div>
    );
  }
}

export default Children;



// WEBPACK FOOTER //
// ./src/app/views/children/Children.js